export const MIN_NAME_CHARACTERS = 2;
export const MAX_PHONE_NUMBERS = 16;
export const MIN_MESSAGE_CHARACTERS = 10;
export const MIN_TITLE_CHARACTERS = 4;
export const MIN_PRICE = 100;
export const MIN_ABOUT_CHARACTERS = 10;
export const MAX_POSTAL_CODE = 8;
export const MIN_STREET = 5;
export const FULL_NAME = 2;
export const MIN_CITY_CHARACTERS = 2;
export const SHIPPING_COST = 69;

//Regex
export const EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
export const creditCardRegex = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14})$/;
